/**
 * Tipos e utilitários compartilhados da fila.
 */

import type { SendEventParams } from '../../utils/sendEvent';

export type QueuePriority = 'high' | 'medium' | 'low';
export type QueueStatus = 'queued' | 'processing' | 'sent' | 'failed' | 'dead';
export type QueueItemType = 'conversion' | 'behavior' | 'pageview';

export interface QueueItem {
  id: string;
  type: QueueItemType;
  params: SendEventParams;
  attempts: number;
  priority: QueuePriority;
  status: QueueStatus;
  createdAt: number;
  nextRetryAt: number;
  occurredAt: number;
  sessionSequence: number;
  processingAt?: number;
  processingTabId?: string;
}

export const FLUSH_INTERVAL_MS = 5000;
export const MAX_EVENT_BYTES = 32_000;
export const QUEUE_ITEM_TTL_MS = 24 * 60 * 60 * 1000;
export const FLUSH_THRESHOLD_ITEMS = 10;

export const DROPPABLE_BEHAVIOR_TYPES = new Set<SendEventParams['type']>([
  'BEHAVIOR_SUMMARY',
  'SCROLL',
  'PAGE_CLICK',
  'ELEMENT_VISIBLE',
  'ELEMENT_ENTER',
  'ELEMENT_EXIT',
]);

export function eventTypeToQueueType(
  eventType: SendEventParams['type']
): QueueItemType {
  if (eventType === 'PAGE_VIEW') return 'pageview';
  const conversionTypes: SendEventParams['type'][] = [
    'PURCHASE',
    'LEAD',
    'ADD_TO_CART',
    'REMOVE_TO_CART',
    'INITIATE_CHECKOUT',
    'ADD_PAYMENT_INFO',
    'VIEW_ITEM',
    'SEARCH',
    'VIEW_CONTENT',
    'CUSTOM_EVENT',
    'CONVERSION',
  ];
  return conversionTypes.includes(eventType) ? 'conversion' : 'behavior';
}

export function getGroupKey(item: QueueItem): string {
  const { config, visitorId, sessionId } = item.params;
  return `${config.pixel}|${visitorId}|${sessionId}`;
}

export interface QueueStats {
  size: number;
  oldestCreatedAt: number | null;
  processing: number;
  failed: number;
}
